import { Link } from 'react-router-dom';

const Item = ({ a }) => {
  const content = (
    <span className="inline-flex items-center gap-2 text-[11px] sm:text-xs uppercase tracking-[0.2em] text-white whitespace-nowrap">
      {a.text}
    </span>
  );
  if (!a.link) return content;
  const external = /^https?:\/\//i.test(a.link);
  if (external) {
    return (
      <a href={a.link} target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity">
        {content}
      </a>
    );
  }
  return (
    <Link to={a.link} className="hover:opacity-80 transition-opacity">
      {content}
    </Link>
  );
};

// Site-wide marquee strip above the navbar. Renders each announcement twice
// (seamless loop with the shared `animate-marquee` → translateX(-50%) keyframe).
export const AnnouncementBar = ({ items = [] }) => {
  if (!items.length) return null;
  const Sequence = () => (
    <div className="flex items-center shrink-0" aria-hidden="false">
      {items.map((a, i) => (
        <span key={`${a.id || i}`} className="flex items-center">
          <Item a={a} />
          <span className="mx-6 text-white/50 select-none">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[60] h-9 bg-[#eb5381] overflow-hidden flex items-center"
    >
      <div className="flex w-max animate-marquee will-change-transform">
        <Sequence />
        <Sequence />
      </div>
    </div>
  );
};
